import projectMapComponent from './project-map.component';

const projectMapModule = angular.module('projectMap', [
])
  .component('projectMap', projectMapComponent)
  .name;

export default projectMapModule;
